import React from 'react'
import MyAccountGuest from './MyAccountGuest'

const IuppContactList = (props) => {
  return (
    <div className='col-12 px-0 contact-list row'>
      <div className='col-12 col-md-6 col-lg-3 py-5'>
        <div
          className='address col-12 logo-footer px-0'
          role='img'
          aria-label={`logo ${process.env.REACT_APP_TITLE || ''}`}
        />
        <div className='col-12 my-3 px-0'>
          <p className='m-0 txt-subtitle'>Banco Itaucard S.A.</p>
          <p className='m-0 txt-subtitle'>CNPJ/MF sob o nº 17.192.451/0001-70</p>
          <p className='m-0 txt-subtitle'>Praça Alfredo Egydio de Souza Aranha,</p>
          <p className='m-0 txt-subtitle'>100, Torre Olavo Setubal, 7º andar</p>
          <p className='m-0 txt-subtitle'>Parque Jabaquara - São Paulo - SP</p>
        </div>
        <div className='col-12 row px-0'>
          <div className='col-2 d-md-none' />
          <div className='col-2 social-icons'>
            <a href='https://www.facebook.com/Iupp-107690693947953/' target='_blank' className='facebook-icon d-block' aria-label='Acessar a nossa página no Facebook em uma página externa' />
          </div>
          <div className='col-2 social-icons'>
            <a href='https://www.instagram.com/iupp/' target='_blank' className='instagram-icon d-block' aria-label='Acessar a nossa página no Instagram em uma página externa' />
          </div>
          <div className='col-2 social-icons'>
            <a href='https://www.youtube.com/channel/UCCwUfTgGBcf9aqx_hV38-KA' target='_blank' className='youtube-icon d-block' aria-label='Acessar o nosso canal no YouTube em uma página externa' />
          </div>
          <div className='col-2 social-icons'>
            <a href='https://twitter.com/iupp' target='_blank' className='twitter-icon d-block' aria-label='Acessar o nosso perfil no Twitter em uma página externa' />
          </div>
          <div className='col-2 d-md-none' />
        </div>
      </div>
      <div className='col-12 col-md-6 col-lg-3 py-5'>
        <h2 className='h3'>Sobre o iupp</h2>
        <ul className='list-unstyled'>
          <li><a href={`https://${process.env.RAZZLE_APP_TENANT_DOMAIN}/accessibility-status`}>Estatuto de acessibilidade</a></li>
          <li><a href={`https://${process.env.RAZZLE_APP_TENANT_DOMAIN}/regulation`}>Regulamentos</a></li>
          <li><a href={`https://${process.env.RAZZLE_APP_TENANT_DOMAIN}/privacy`}>Políticas de privacidade</a></li>
          <li><a href={`https://${process.env.RAZZLE_APP_TENANT_DOMAIN}/terms`}>Termos de uso</a></li>
        </ul>
      </div>
      <div className='col-12 col-md-6 col-lg-3 py-5'>
        <h3 className='h3'>Tá com dúvida?</h3>
        <ul className='list-unstyled'>
          <li><a href={`${process.env.RAZZLE_MESSAGE_ZENDESK_URL}hc/pt-br/requests/new`} target='_blank'>Fale com a gente</a></li>
          <li><a href={`${process.env.RAZZLE_MESSAGE_ZENDESK_URL}hc/pt-br`} target='_blank'>Dúvidas frequentes</a></li>
          <li><a href={`${process.env.RAZZLE_MESSAGE_ZENDESK_URL}hc/pt-br/articles/360037500412-como-entro-em-contato-com-o-atendimento-do-iupp-`} target='_blank'>Telefones úteis</a></li>
        </ul>
      </div>
      <div className='col-12 col-md-6 col-lg-3 py-5'>
        <h3 className='h3'>Minha conta</h3>
        <MyAccountGuest />
      </div>
    </div>
  )
}

export default IuppContactList
